// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_Lzv","cls2":"WorkCard-cls2_PQ3 WorkCard-cls1_Lzv"};